// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"default-apps_ui_src_app_view-models_sale_view-model_ts-node_modules_se-fe-card_fesm2015_se-fe-01c6b4":"7faad0bbbed21533","apps_ui_src_app_order-history_order-history_component_ts":"a2c299f4e527bcb3","apps_ui_src_app_order-details_order-details_component_ts":"d730c2ca111717f7"}[chunkId] + ".js";
};